/**************************************************************************************************
//
//  Description:  gazAPI slice of Redux store
//
//  Copyright:    © 2020 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   30.10.20 Joel Benford               Initial Revision.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion */

/* #region imports */
import { createSlice } from "@reduxjs/toolkit";
//#endregion imports

//State
const slice = createSlice({
  name: "gazApi",
  initialState: "",
  reducers: {
    gazApiBaseSet: (gazApi, action) => {
      //console.log("gazApiBaseSet", gazApi, action);
      return action.payload
    }
  }
});

// Actions
export const { gazApiBaseSet } = slice.actions;

// Reducers
export default slice.reducer;
